import {Injectable, Injector} from '@angular/core';
import {HttpClient} from '@angular/common/http';

export class AppConfig {
  public gatewayUrl?: string;
  public dashboardRefreshRateMs = 60000;

  static from(data: any): AppConfig {
    if (!data) {
      return undefined;
    }
    return Object.assign(new AppConfig(), data);
  }

  constructor() {}
}

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private appConfig: AppConfig;

  constructor(private injector: Injector) { }

  load() {
    return this.injector.get(HttpClient).get('assets/app-config.json')
    .toPromise()
    .then(
      data => this.appConfig = AppConfig.from(data),
      (error) => {
        console.warn('Error loading app-config.json', error);
      }
    );
  }

  get config() {
    return this.appConfig;
  }
}
